import React from "react";
import styles from "./help.module.scss";
import { withTranslation } from "react-i18next";
import { helpContactInfo } from "./helpRegionData.js";

const Help = (props) => {
  const market = props.market?.toUpperCase();
  const contactInfo = helpContactInfo[market];

  return contactInfo ? (
    <div className="pageWrapper">
      <div className="pagePadding">
        <div className={styles.headerWrapper}>
          <span
            id="helpHeader"
            data-testid="helpHeader"
            className={styles.helpHeader}
          >
            {props.t("Help.header")}
          </span>
          <span data-testid="contactSubHeader" className={styles.helpSubheader}>
            {props.t(contactInfo.contactSubHeader)}
          </span>
          {contactInfo.displayLink && (
            <span
              id="subHeader"
              data-testid="contactLink"
              className={styles.helpSubheader}
            >
              <a
                href={contactInfo.contactLink}
                target="_blank"
                rel="noreferrer"
              >
                {contactInfo.contactLink}
              </a>
            </span>
          )}
        </div>
        {contactInfo.displayContact && (
          <div className={styles.contactWrapper}>
            <span
              id="contactHeader"
              data-testid="contactHeader"
              className={styles.contactHeader}
            >
              {props.t("Help.contactHeader")}
            </span>
            <hr className={styles.line} />

            {contactInfo.displayPhone && (
              <div
                className={styles.contactInfo}
                data-testid="phoneNumber"
                id="phoneNumber"
              >
                <span>{props.t(contactInfo.addressTitle)}</span>

                {contactInfo.additionalAddress ? (
                  <span>{props.t(contactInfo.address1)}</span>
                ) : null}
                {contactInfo.additionalAddress ? (
                  <span>{props.t(contactInfo.address2)}</span>
                ) : null}
                <span>{contactInfo.phoneNumber}</span>
              </div>
            )}
            {contactInfo.contactEmail && (
              <span className={styles.contactInfo} data-testid="contactEmail">
                {props.t(contactInfo.contactEmail)}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  ) : null;
};

export default withTranslation("emp")(Help);
